import api from './axiosConfig';

export interface Role {
  id: number;
  rolename: string;
  description: string;
}

const getAllRoles = async (): Promise<Role[]> => {
  try {
    const response = await api.get('roles');
    return response.data;
  } catch (error) {
    console.error('Error fetching roles:', error);
    return [];
  }
};

export const RoleService = {
  getAllRoles
};
